/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useState, useEffect } from 'react';
import './checkbox-input.scss';

const CheckboxInput = ({
  checkboxId,
  checkboxName,
  defaultChecked,
  checkMessage,
}) => {
  const [check, setCheck] = useState(false);

  useEffect(() => {
    if (defaultChecked) {
      setCheck(defaultChecked);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateChecked = (keyCode) => {
    // for ada compliance
    if (keyCode === 'Space' || keyCode === 'Enter') {
      setCheck(!check);
      document.getElementById(`${checkboxId}`).checked = !check;
    } else {
      setCheck(document.getElementById(`${checkboxId}`).checked);
    }
  };

  return (
    <div onClick={() => updateChecked()} className="checkbox" onKeyDown={(e) => updateChecked(e.code)}>
      <input id={checkboxId} type="checkbox" className="checkbox-hidden" name={checkboxName} checked={check} autoComplete="off" readOnly aria-hidden="true" />
      <label className="fs-body-2 checkbox-label" htmlFor={checkboxId}>
        <div className="checkbox-container d-flex align-items-center">
          <div className="checkbox-selector">
            <div className="checkbox-sizebox" role="checkbox" aria-checked={check} aria-labelledby="checkLabel" tabIndex="0" />
          </div>
          <p id="checkLabel" className="checkbox-message c-light-midnight ff-graphik fs-p3" role="alert">{checkMessage}</p>
        </div>
      </label>
    </div>
  );
};

export default CheckboxInput;
